import { bindTemplateProxy } from "./CustomTemplates/bindTemplateProxy.js";
import { getTplStateStore } from "./CustomTemplates/utils.js";
import { bindListeners } from "./bindListeners.js";
import { setRealProperties } from "./compute/setRealProperties.js";
import { RenderTag } from "./enums.js";
export function unmountTree(mountPoint) {
  mountPoint.replaceChildren();
}
export function mountTree(root, initializedElement) {
  root.mounted = true;
  window.DISABLE_REACT_FLUSH_SYNC = false;
  let current = root.child;
  const portalElements = [];
  while (current) {
    current.mounted = true;
    if (current.tag === RenderTag.BRICK) {
      var _current$tplHostMetad;
      const tagName = current.type;
      if (tagName.includes("-") && !customElements.get(tagName)) {
        // eslint-disable-next-line no-console
        console.error(`Undefined custom element: ${tagName}`);
      }

      // istanbul ignore if
      if (tagName === "basic-bricks.script-brick") {
        // eslint-disable-next-line no-console
        console.warn("`basic-bricks.script-brick` is deprecated, please take caution when using it");
      }
      const element = initializedElement && current === root.child ? initializedElement : document.createElement(tagName);
      current.element = element;
      if (current.slotId) {
        element.setAttribute("slot", current.slotId);
      }
      if (current.iid) {
        element.dataset.iid = current.iid;
      }
      if ((_current$tplHostMetad = current.tplHostMetadata) !== null && _current$tplHostMetad !== void 0 && _current$tplHostMetad.tplStateStoreId) {
        element.dataset.tplStateStoreId = current.tplHostMetadata.tplStateStoreId;
      }
      setRealProperties(element, current.properties);
      bindListeners(element, current.events, current.runtimeContext);
      if (current.tplHostMetadata) {
        // 先设置属性，再设置 `$$tplStateStore`，这样，当触发属性设置时，
        // 避免初始化的一次 state update 操作及其 onChange 事件。
        element.$$tplStateStore = getTplStateStore({
          tplStateStoreId: current.tplHostMetadata.tplStateStoreId,
          tplStateStoreMap: current.runtimeContext.tplStateStoreMap
        }, "mount");
      }
      bindTemplateProxy(current);
      if (current.portal) {
        portalElements.push(element);
      } else if (current.return) {
        let currentReturn = current.return;
        while (currentReturn) {
          if (currentReturn.tag === RenderTag.ABSTRACT) {
            currentReturn = currentReturn.return;
          } else {
            if (!currentReturn.childElements) {
              currentReturn.childElements = [];
            }
            currentReturn.childElements.push(element);
            break;
          }
        }
      }
    }
    if (current.child) {
      current = current.child;
    } else if (current.sibling) {
      current = current.sibling;
    } else {
      var _currentReturn;
      let currentReturn = current.return;
      while (currentReturn) {
        // Append elements inside out
        if (currentReturn.tag !== RenderTag.ABSTRACT && currentReturn.childElements) {
          if (currentReturn.tag === RenderTag.ROOT) {
            var _currentReturn$contai;
            (_currentReturn$contai = currentReturn.container) === null || _currentReturn$contai === void 0 || _currentReturn$contai.append(...currentReturn.childElements);
          } else {
            currentReturn.element.append(...currentReturn.childElements);
          }
          currentReturn.childElements = undefined;
        }
        if (currentReturn.tag === RenderTag.ROOT && portalElements.length > 0) {
          const portal = typeof currentReturn.createPortal === "function" ? currentReturn.createPortal() : currentReturn.createPortal;
          portal.append(...portalElements);
        }
        if (currentReturn.sibling) {
          break;
        }
        currentReturn = currentReturn.return;
      }
      current = (_currentReturn = currentReturn) === null || _currentReturn === void 0 ? void 0 : _currentReturn.sibling;
    }
  }
  setTimeout(() => {
    window.DISABLE_REACT_FLUSH_SYNC = true;
  });
}
//# sourceMappingURL=mount.js.map